import { defineComponent } from "vue";
import { EMAIL_REGEXP } from "@/constants/regexp";
import { CountryStates } from "@/constants/states";

const ValidationMixin = defineComponent({
  methods: {
    requiredValidator: (v: any): boolean | string =>
      (v !== "" && v !== null && v !== undefined && v.toString().trim() !== "") || "Field is required",
    emailValidator: (email: string): boolean | string => {
      return EMAIL_REGEXP.test(email) || "Email is not valid";
    },
    digitsValidator: (v: any): boolean | string =>
      (v.toString() && !isNaN(v) && !isNaN(parseFloat(v))) || "Only digits allowed",
    selectValidator: (v: any[]): boolean | string => (v && v.length > 0) || "Required at least one value",
    phoneValidator: (v: string): boolean | string => {
      const len = (v || "").replace(/ /g, "").length;
      if (len === 0) return true;
      return len === 11 || "Phone number is incorrect";
    },
    validateVIN: (v: string): boolean | string => (v && v.length === 17) || "VIN code is incorrect",
    stateValidator: (v: string): boolean | string => {
      if (v && v.length !== 2) return "Two letters state name";

      const code = v.toUpperCase();

      const allStates = Object.values(CountryStates).flat();

      return (code && allStates.includes(code)) || "State not found";
    },
    dateInputValidator: (v: string): boolean | string => {
      const re = /^[0-1]\d\/[0-3]\d\/\d{4}$/;
      return re.test(v) || "Date is not valid";
    },
    yearLengthValidator: (v: string): boolean | string => !v || (v && v.length === 4) || "Incorrect year",
    positiveNumber: (v: number): boolean | string => (v && !!Number(v) && v > 0) || "Only positive numbers allowed",
    fileRequiredValidator: (v: File[] | File): boolean | string => {
      if (Array.isArray(v)) {
        return (v[0] && !!v[0].name) || "File is required";
      }

      return Boolean(v.name) || "File is required";
    },
    arrayRequiredValidator: (v: any[]): boolean | string => {
      return (Array.isArray(v) && v.length > 0) || "Field is required";
    },
  },
});

export default ValidationMixin;
